import { render } from "./JewelriesRandom.vue?vue&type=template&id=54083628"
import script from "./JewelriesRandom.vue?vue&type=script&lang=js"
export * from "./JewelriesRandom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__